import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { CATEGORIES } from '@/data/categories';

import { Section, SectionHeading } from '../common/Section';

export function CategoryGrid() {
  return (
    <Section id="categorias" tone="cream" size="md">
      <SectionHeading
        eyebrow="Comece por aqui"
        title="Escolha por categoria"
        description="Seis atalhos para chegar rápido ao que o seu pet precisa. O catálogo completo continua a um clique."
        className="mb-10"
      />

      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {CATEGORIES.map((category) => (
          <li key={category.id}>
            <Link
              to={`/catalogo${category.query}`}
              className="group relative flex h-full flex-col overflow-hidden rounded-3xl border-2 border-sand-300 bg-white shadow-card transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-card-hover"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-cream-200">
                <img
                  src={category.image}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className="absolute top-3 left-3 grid size-11 place-items-center rounded-2xl bg-white/90 text-2xl backdrop-blur-sm"
                  aria-hidden="true"
                >
                  {category.emoji}
                </span>
              </div>

              <div className="flex flex-1 flex-col gap-1.5 p-5">
                <h3 className="font-display text-lg font-bold text-brown-900 transition-colors group-hover:text-orange-600">
                  {category.title}
                </h3>
                <p className="flex-1 text-sm text-brown-700">{category.description}</p>

                <span className="mt-2 inline-flex items-center gap-1.5 font-display text-sm font-bold text-orange-600">
                  Ver produtos
                  <ArrowRight
                    className="size-4 transition-transform duration-300 group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </Section>
  );
}
